import tinycolor from "tinycolor2";
import { grey } from "@mui/material/colors";
import { PaletteMode } from "@mui/material";

const primary = "#0d637d"; // "#388e3c";
const secondary = "#be8f01";
const warning = "#FFC260";
const success = "#3e99b5";
const info = "#9013FE";

// const primary = "#455a64";
// const secondary = "#e91e63";

// const warning = "#FFC260";
// const success = "#3CD4A0";
// const info = "#9013FE";

//const lightenRate = 7.5;
const darkenRate = 5;

export const lightTheme = {
  palette: {
    mode: "light" as PaletteMode,
    primary: {
      main: tinycolor(primary).setAlpha(1).toRgbString(),
      dark: tinycolor(primary).darken(10).toHexString(),
      light: tinycolor(primary).lighten(10).toHexString(),
    },
    secondary: {
      main: secondary,
      dark: tinycolor(secondary).darken(10).toHexString(),
      light: tinycolor(secondary).lighten(10).toHexString(),
    },
    warning: { main: warning },
    success: { main: success },
    info: { main: info },
    background: {
      //default: `linear-gradient(to right, ${primary} 30%, ${secondary} 90%)`,
      //paper: `linear-gradient(to right, ${primary} 30%, ${secondary} 90%)`,
      //default: "#ffffff",
      // paper: "#121212",
    },
    text: {
      primary: "#000",
      secondary: "#6E6E6E",
    },
    action: {
      selected: "rgb(211, 237, 245)", // "rgba(0, 128, 0, 0.2)",
      hover: tinycolor("rgba(211, 237, 245, 0.2)")
        .darken(darkenRate)
        .toHexString(),
    },
  },
};

export const darkTheme = {
  palette: {
    mode: "dark" as PaletteMode,
    primary: { main: tinycolor(primary).darken(darkenRate).toHexString() },
    secondary: { main: tinycolor(secondary).darken(darkenRate).toHexString() },
    warning: { main: tinycolor(warning).darken(darkenRate).toHexString() },
    success: { main: tinycolor(success).darken(darkenRate).toHexString() },
    info: { main: tinycolor(info).darken(darkenRate).toHexString() },
    background: {
      //default: `linear-gradient(to right, ${primary} 30%, ${secondary} 90%)`,
      //paper: `linear-gradient(to bottom, ${secondary} 30%, ${primary} 90%)`,
      //default: "#121212",
      //paper: "#121212",
    },
    text: {
      primary: "#fff",
      secondary: grey[500],
    },
    action: {
      selected: warning,
      hover: tinycolor(warning).darken(darkenRate).toHexString(),
    },
  },
};
